<div class="d-flex justify-content-center my-5">
  <img class="img-fluid" *imageWithBrandPrefix="'/assets/images/Application_Form_Logo.png'" alt="{{brandName}} Logo">
</div>

<div class="text-center mb-2">
  <div *ngIf="!sendEmail">
    <p class="text-description"> This verification link has been used once and cannot be reused.</p>
    <p class="text-description">Click here to receive another verification email.</p>
  </div>
  <div *ngIf="sendEmail">
    <p class="text-description">Welcome to {{brandName}}</p>
    <p class="text-description">You entered
      <strong>{{email}}</strong> as the contact email address for your account,</p>
    <p class="text-description">Please check your inbox for the verification email that we have sent you.</p>
  </div>
</div>

<div class="col-2 offset-5 mt-5">
  <button *ngIf="!sendEmail" class="btn btn-block btn-lg btn-greengo" (click)="resendEmail()" npFocusOutClicked>Resend</button>
  <button *ngIf="sendEmail" class="btn btn-block btn-lg btn-greengo" (click)="resendEmail()" npFocusOutClicked>Email didn't
    arrive?</button>
</div>